import {FiEdit2, FiX} from "react-icons/fi";
import {HiOutlineLockClosed} from "react-icons/hi";

import {Button} from "@/components/button/Button.tsx";
import {FormSubtext} from "@/components/formSubtext/FormSubtext.tsx";
import {Icon} from "@/components/icon/Icon.tsx";
import {IconButton} from "@/components/iconButton/IconButton.tsx";
import {TagSwatch} from "@/components/tagSwatch/TagSwatch.tsx";
import {Tooltip} from "@/components/toolTip/Tooltip.tsx";
import {AnalyzerSettingsFieldProps} from "@/pages/analyzer/Analyzer.types.ts";

import styles from "./AnalyzerSettingsField.module.scss";

export const AnalyzerSettingsField = ({
  label,
  subText,
  chips,
  onRemove,
  editing,
  onEdit,
  onCancel,
  onSave,
  locked,
  disabled,
  error,
  children,
}: AnalyzerSettingsFieldProps) => {
  return (
    <div className={styles.field}>
      <div className={styles.label}>{label}</div>
      {locked ? (
        <div className={styles.lockedBox}>
          <Icon icon={HiOutlineLockClosed} size="chip" removeDivDimensions className={styles.lockIcon} />
          <div>
            <div className={styles.lockedTitle}>{locked.title}</div>
            <div className={styles.lockedBody}>To change them, just ask me here — e.g. “{locked.example}”</div>
          </div>
        </div>
      ) : editing ? (
        children
      ) : (
        <div className={styles.box}>
          <div className={styles.chips}>
            {chips.map(({name, colorHex}) => (
              <span key={name} className={styles.chip}>
                <span className={styles.chipLabel}>
                  {colorHex && <TagSwatch color={colorHex} />}
                  <Tooltip tooltipContent={name} delayMs={500}>
                    <span className={styles.chipText}>{name}</span>
                  </Tooltip>
                </span>
                <IconButton
                  icon={FiX}
                  size="fitIcon"
                  variant="ghost"
                  aria-label={`Remove ${name}`}
                  disabled={disabled}
                  onClick={() => onRemove(name)}
                />
              </span>
            ))}
          </div>
          <Button variant="ghost" size="fitContent" disabled={disabled} onClick={onEdit} className={styles.editButton}>
            <Icon icon={FiEdit2} removeDivDimensions />
            Edit
          </Button>
        </div>
      )}
      {!locked && <FormSubtext subText={subText} error={error} alwaysShowSubText className="mt-0" />}
      {editing && (
        <div className={styles.editActions}>
          <Button variant="secondary" size="extraSmall" className={styles.editAction} onClick={onCancel}>
            Cancel
          </Button>
          <Button variant="primary" size="extraSmall" className={styles.editAction} onClick={onSave}>
            Save
          </Button>
        </div>
      )}
    </div>
  );
};
